import { lazy } from 'react'

export const UpdateUserOrProfileAsync = lazy(() => import('./UpdateUserOrProfile')
    .then((module) => ({ default: module.UpdateUserOrProfile })
    ))
